<h5>{{ titleKey | translate }}</h5>
<p *ngIf="descriptionKey" class="description" innerHTML="{{ descriptionKey | translate }}"></p>

<div class="table-responsive myip-details">
  <table class="table myip-details">
    <thead>
      <tr>
        <th class="select"></th>
        <th class="ip">
          {{ 'IPs' | translate }}
          <app-help tooltipKey="IpExceptionExemple" tooltipPlacement="right" />
        </th>
        <th class="comment">{{ 'Comments' | translate }}</th>
        <th class="actions">Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (ips().length) {
        @for (ip of ips(); track ip.ip ?? $index) {
          <tr>
            <td class="select">
              <label *ngIf="!ip.editing" class="ogo-checkbox-container">
                <input (click)="toggleSelected(ip)" [checked]="!!ip.selected" type="checkbox" />
                <span class="ogo-checkbox-checkmark"></span>
              </label>
            </td>
            <td>
              <span *ngIf="!ip.editing">{{ ip.ip }}</span>
              <input
                class="form-control form-control-sm"
                #ipInput
                (keydown)="onKeyDown($event, ip)"
                *ngIf="ip.editing"
                [(ngModel)]="ip.ip"
                style="width: 350px; height: 33px"
              />
            </td>
            <td>
              <span *ngIf="!ip.editing" [title]="ip.comment">
                {{ ip.comment }}
              </span>
              <textarea
                (keydown)="onKeyDown($event, ip)"
                *ngIf="ip.editing"
                [(ngModel)]="ip.comment"
                maxlength="255"
                placeholder="{{ 'CommentsOptional' | translate }}"
                style="
                  height: 100%;
                  width: 100%;
                  position: relative;
                  top: -5px;
                  border: 1px solid #dfdfdf;
                  border-radius: 2px;
                "
              ></textarea>
            </td>
            <td class="actions icon-container">
              @if (!ip.editing) {
                <button
                  (click)="startIpExceptionEditing(ip)"
                  [disabled]="isEditing()"
                  class="btn btn-transparent p-1 icofont icofont-edit-alt"
                  title="{{ 'Modifier' | translate }}"
                ></button>
                <button
                  (click)="deleteIpException(ip)"
                  class="btn btn-transparent p-1 icofont icofont-ui-delete"
                  title="{{ 'supprimer' | translate }}"
                ></button>
              } @else {
                <button
                  (click)="validateEdit(ip)"
                  [disabled]="ip.ip.length == 0"
                  [reEnableButton]="busy"
                  class="btn btn-transparent p-1 icofont icofont-check"
                  disableOnClick
                  title="{{ isNew(ip) ? ('ajouter' | translate) : 'Validate' }}"
                ></button>
                <button
                  (click)="cancelEdit(ip)"
                  class="btn btn-transparent p-1 icofont icofont-close"
                  title="{{ 'Annuler' | translate }}"
                ></button>
              }
            </td>
          </tr>
        }
      } @else {
        <tr>
          <td
            [attr.colspan]="4"
            [ngStyle]="{ padding: '15px' }"
            class="text-center"
          >
            {{ noneLabel | translate }}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<div class="flex-align-items float-left" style="margin-top: 10px">
  <a (click)="ips().length && selectOrDeselectAll()" class="ogo-link mr-3" style="font-weight: bold">{{
    (allSelected() ? 'DeselectAll' : 'SelectAll') | translate
  }}</a>
  <div class="icon-container">
    <i
      (click)="ips().length && copyToClipboard()"
      [ngClass]="ips().length ? [] : ['disabled']"
      class="icofont icofont-ui-copy"
      title="{{ 'CopyList' | translate }}"
    ></i>
    <i
      (click)="!isEditing() && !pasting && pasteFromClipboard()"
      [ngClass]="isEditing() || pasting ? ['disabled'] : []"
      class="icofont icofont-notepad"
      title="{{ 'Paste' | translate }}"
    ></i>
    <i
      (click)="ips().length && downloadCsv()"
      [ngClass]="ips().length ? [] : ['disabled']"
      class="icofont icofont-download"
      title="{{ 'DownloadList' | translate }}"
    ></i>
    <i
      (click)="selectedExceptions().length && !isEditing() && deleteBatchException()"
      [ngClass]="selectedExceptions().length && !isEditing() ? [] : ['disabled']"
      class="icofont icofont-ui-delete"
      title="{{ 'supprimer' | translate }}"
    ></i>
  </div>
</div>
<div class="adding-ips">
  <a (click)="addIpException()" [ngClass]="isEditing() ? 'a-disabled' : ''" class="ogo-link">
    + {{ addLabelKey ?? 'AddAnIPOrCIDR' | translate }}
  </a>
</div>
